module.exports = __webpack_public_path__ + "img/vertical_4_5_8004.3acf366b.png";